"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layers = require("@nebula.gl/layers");

var _constants = require("@luma.gl/constants");

var _style = require("../style");

var _nebulaLayer = _interopRequireDefault(require("../nebula-layer"));

var _utils = require("../utils");

var _deckCache = _interopRequireDefault(require("../deck-renderer/deck-cache"));

var _NEBULA_TO_DECK_DIREC;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEBULA_TO_DECK_DIRECTIONS = (_NEBULA_TO_DECK_DIREC = {}, _defineProperty(_NEBULA_TO_DECK_DIREC, _style.ArrowStyles.NONE, {
  forward: false,
  backward: false
}), _defineProperty(_NEBULA_TO_DECK_DIREC, _style.ArrowStyles.FORWARD, {
  forward: true,
  backward: false
}), _defineProperty(_NEBULA_TO_DECK_DIREC, _style.ArrowStyles.BACKWARD, {
  forward: false,
  backward: true
}), _defineProperty(_NEBULA_TO_DECK_DIREC, _style.ArrowStyles.BOTH, {
  forward: true,
  backward: true
}), _NEBULA_TO_DECK_DIREC);

var SegmentsLayer = /*#__PURE__*/function (_NebulaLayer) {
  _inherits(SegmentsLayer, _NebulaLayer);

  var _super = _createSuper(SegmentsLayer);

  function SegmentsLayer(config) {
    var _this;

    _classCallCheck(this, SegmentsLayer);

    _this = _super.call(this, config);

    _defineProperty(_assertThisInitialized(_this), "deckCache", void 0);

    _defineProperty(_assertThisInitialized(_this), "noBlend", void 0);

    _defineProperty(_assertThisInitialized(_this), "highlightColor", void 0);

    _defineProperty(_assertThisInitialized(_this), "arrowSize", void 0);

    _defineProperty(_assertThisInitialized(_this), "rounded", void 0);

    _defineProperty(_assertThisInitialized(_this), "dashed", void 0);

    _defineProperty(_assertThisInitialized(_this), "markerLayerProps", void 0);

    _this.deckCache = new _deckCache["default"](config.getData, function (data) {
      return config.toNebulaFeature(data);
    });
    _this.enableSelection = true;
    var _config$enablePicking = config.enablePicking,
        enablePicking = _config$enablePicking === void 0 ? true : _config$enablePicking,
        _config$noBlend = config.noBlend,
        noBlend = _config$noBlend === void 0 ? false : _config$noBlend,
        _config$rounded = config.rounded,
        rounded = _config$rounded === void 0 ? true : _config$rounded,
        _config$dashed = config.dashed,
        dashed = _config$dashed === void 0 ? false : _config$dashed,
        _config$markerLayerPr = config.markerLayerProps,
        markerLayerProps = _config$markerLayerPr === void 0 ? null : _config$markerLayerPr;
    Object.assign(_assertThisInitialized(_this), {
      enablePicking: enablePicking,
      noBlend: noBlend,
      rounded: rounded,
      dashed: dashed,
      markerLayerProps: markerLayerProps
    });
    return _this;
  }

  _createClass(SegmentsLayer, [{
    key: "getMouseOverSegment",
    value: function getMouseOverSegment() {
      // TODO: remove references
      return null;
    }
  }, {
    key: "_calcMarkerPercentages",
    value: function _calcMarkerPercentages(nf) {
      var arrowPercentages = nf.style.arrowPercentages;

      if (arrowPercentages) {
        return arrowPercentages;
      }

      var arrowStyle = nf.style.arrowStyle || _style.DEFAULT_STYLE.arrowStyle;
      if (arrowStyle === _style.ArrowStyles.NONE) return [];
      var arrowCount = Math.min(nf.style.arrowCount || _style.DEFAULT_STYLE.arrowCount, _style.MAX_ARROWS);
      return [[0.5], [0.33, 0.66], [0.25, 0.5, 0.75]][arrowCount - 1];
    }
  }, {
    key: "_getHighlightedObjectIndex",
    value: function _getHighlightedObjectIndex(_ref) {
      var nebula = _ref.nebula;
      var deckglMouseOverInfo = nebula.deckglMouseOverInfo;

      if (deckglMouseOverInfo) {
        var originalLayer = deckglMouseOverInfo.originalLayer,
            index = deckglMouseOverInfo.index;

        if (originalLayer === this) {
          return index;
        }
      } // no object


      return -1;
    }
  }, {
    key: "render",
    value: function render(_ref2) {
      var nebula = _ref2.nebula;
      var defaultColor = [0x0, 0x0, 0x0, 0xff];
      var _this$deckCache = this.deckCache,
          objects = _this$deckCache.objects,
          updateTrigger = _this$deckCache.updateTrigger;
      return new _layers.PathMarkerLayer({
        id: "segments-".concat(this.id),
        data: objects,
        opacity: 1,
        // @ts-ignore
        fp64: false,
        rounded: this.rounded,
        pickable: true,
        sizeScale: this.arrowSize || 6,
        parameters: {
          depthTest: false,
          blend: !this.noBlend,
          blendEquation: _constants.MAX
        },
        getPath: function getPath(nf) {
          return nf.geoJson.geometry.coordinates;
        },
        // @ts-ignore
        getColor: function getColor(nf) {
          return (0, _utils.toDeckColor)(nf.style.lineColor, defaultColor);
        },
        getWidth: function getWidth(nf) {
          return nf.style.lineWidthMeters || 1;
        },
        getZLevel: function getZLevel(nf) {
          return nf.style.zLevel * 255;
        },
        getDirection: function getDirection(nf) {
          return NEBULA_TO_DECK_DIRECTIONS[nf.style.arrowStyle];
        },
        // @ts-ignore
        getMarkerColor: function getMarkerColor(nf) {
          return (0, _utils.toDeckColor)(nf.style.arrowColor, defaultColor);
        },
        getMarkerPercentages: this._calcMarkerPercentages,
        updateTriggers: {
          all: updateTrigger
        },
        highlightedObjectIndex: this._getHighlightedObjectIndex({
          nebula: nebula
        }),
        highlightColor: (0, _utils.toDeckColor)(this.highlightColor),
        dashJustified: this.dashed,
        getDashArray: this.dashed ? function (nf) {
          return nf.style.dashArray;
        } : null,
        markerLayerProps: this.markerLayerProps || _layers.PathMarkerLayer.defaultProps.markerLayerProps,
        nebulaLayer: this
      });
    }
  }]);

  return SegmentsLayer;
}(_nebulaLayer["default"]);

exports["default"] = SegmentsLayer;